//test
export const getCount = state => {
    return state.count
}

export const groupid = state => {
    return state.groupid
}

export const getuser = state => {
	return state.user
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js